import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-12 lg:px-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-14 gap-6">
          <div>
            <p className="text-foreground-400 text-sm font-medium tracking-wide uppercase mb-2">Browse Categories</p>
            <h2 className="text-foreground-950 text-4xl md:text-5xl font-bold font-heading">All Collections</h2>
          </div>
          <p className="text-foreground-600 text-base leading-relaxed max-w-[500px]">
            Explore our comprehensive Kakobuy Spreadsheet categories. Each category links directly to verified product collections on KaSpreadsheet, updated weekly with the latest finds.
          </p>
        </div>

        {/* Category Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-10">
          {categories.map((cat) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-100 rounded-2xl overflow-hidden hover:bg-background-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-52 md:h-60 overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={`Kakobuy Spreadsheet ${cat.name} Category`}
                  title={`Kakobuy Spreadsheet ${cat.name}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <span className="inline-block px-3 py-1 bg-accent-100 text-foreground-950 text-xs font-semibold rounded-md mb-3 whitespace-nowrap">
                  {cat.name}
                </span>
                <h3 className="text-foreground-950 text-lg md:text-xl font-bold font-heading leading-snug">
                  Top Rated {cat.name}
                </h3>
              </div>
            </a>
          ))}
        </div>

        {/* "More" card */}
        <div className="text-center mt-8">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 h-12 px-8 rounded-full border border-foreground-200 text-foreground-700 text-sm font-medium hover:bg-foreground-100 hover:text-foreground-950 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            View All Categories
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}